var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2308C0 6.81905 6.81905 0 15.2308 0C23.6425 0 30.4615 6.81905 30.4615 15.2308C30.4615 23.6425 23.6425 30.4615 15.2308 30.4615C6.81905 30.4615 0 23.6425 0 15.2308Z",
    fill: "#FF8319"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03306 8.75H7.53391L7.83286 9.14973L12.9438 15.9835L7.81654 21.5225L7.42791 21.9423H8H9.18578H9.29503L9.36924 21.8621L13.7781 17.0992L17.3253 21.842L17.4003 21.9423H17.5255H21.5607H22.0599L21.7609 21.5426L16.3554 14.315L21.118 9.16982L21.5067 8.75H20.9346H19.7488H19.6396L19.5653 8.83018L15.5211 13.1993L12.2685 8.85027L12.1935 8.75H12.0683H8.03306ZM18.0881 20.5687L10.276 10.1234H11.5054L19.3175 20.5687H18.0881Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bf07893e044279a1b6cc6d223ddb6580.svg";
export { ForwardRef as ReactComponent };